export default __webpack_public_path__ + "static/media/hema-compressed.2da0b4ec.jpg";